import request from "utils/request";
import { calculateGroupStats } from "actions/stats";

export function toggleGroup(groupId) {
  return {
    type: "TOGGLE_GROUP",
    groupId,
  };
}

export function addGroup(group) {
  return async (dispatch) => {
    try {
      group.id = Math.floor(1000000 + Math.random() * 9000000); // random tmp id
      group.tmp = true;

      const groupWithStats = calculateGroupStats(group);

      dispatch({
        type: "ADD_GROUP",
        group: groupWithStats,
      });

      await request({
        url: `groups`,
        method: "POST",
        action: "ADD_GROUP",
        body: group,
        groupId: group.id,
      });
    } catch (errors) {}
  };
}

export function editGroup(group) {
  return async (dispatch) => {
    try {
      dispatch({
        type: "EDIT_GROUP",
        group,
      });

      await request({
        url: `groups/${group.id}`,
        method: "PUT",
        action: "EDIT_GROUP",
        body: group,
        groupId: group.id,
      });
    } catch (errors) {}
  };
}

export function deleteGroup(groupId) {
  return async (dispatch) => {
    try {
      dispatch({
        type: "DELETE_GROUP",
        groupId,
      });

      await request({
        action: "DELETE_GROUP",
        url: "groups/" + groupId,
        method: "DELETE",
        groupId,
      });
    } catch (e) {
      if (e instanceof Error) {
        console.log("delete group failed", e);
      }
    }
  };
}
